import React, { useState } from "react";

const ScamAlertBanner = () => {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    setVisible(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'relative', // Not fixed — scrolls with the page
        top: 0,
       width: '100%',
        zIndex: 9,
        backgroundColor: '#f9f9f9',
        color: '#1e1e1e',
        padding: '10px 16px',
        fontSize: '14px',
        borderBottom: '1px solid #ddd',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.05)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <svg width="16" height="16" fill="#00b0ca" viewBox="0 0 24 24">
          <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm1 15h-2v-2h2zm0-4h-2V7h2z" />
        </svg>
        <span>
          <strong>Stay vigilant:</strong> Never share personal info with unverified contacts. Your data security is our priority.{' '}
          <a
            href="https://www.twrecruitment.com/recruitment-scam-alert"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#0073e6', textDecoration: 'underline' }}
          >
            Learn more &gt;
          </a>
        </span>
      </div>
      <button
        onClick={handleClose}
        style={{
          marginLeft: '16px',
          background: 'none',
          border: 'none',
          color: '#0073e6',
          textDecoration: 'underline',
          cursor: 'pointer',
          fontSize: '14px',
        }}
        aria-label="Close alert"
      >
        Close
      </button>
    </div>
  );
};

export default ScamAlertBanner;
